import { render, staticRenderFns } from "./auction-status.vue?vue&type=template&id=6a90d6ab&scoped=true"
import script from "./auction-status.vue?vue&type=script&lang=js"
export * from "./auction-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90d6ab",
  null
  
)

export default component.exports